import { defineStore } from "pinia";
import { fetchData, createData, updateData, deleteData } from "@/api/axiosHelper";



export const useExpenseStore = defineStore('expense', {
  state: () => ({
    expenses: [],
    expense: null,
    isLoading: false, // 로딩 상태 추가
    // '추가' 버튼이 눌린 횟수 — keep-alive 로 캐시된 /expenses/new 폼이 "새 작성 요청"을
    // 감지해 초안을 비우는 신호 (2026-11-03). 탭 전환으로 돌아온 경우엔 값이 안 바뀌므로
    // 작성 중 초안은 보존되고, '추가'를 눌렀을 때만 빈 폼이 된다.
    newFormGen: 0,
  }),
  actions: {
    requestNewForm() { this.newFormGen += 1; },
    async fetchExpenses(filters = {}) {
      this.isLoading = true; // 로딩 시작
      try{        
          // 상태 필터 처리
        if (filters.status === "incompleted") {
          // 진행중: completed 상태 제외
          filters.exclude_status = "completed";
          delete filters.status; // 기존 status 키 제거
        }

        const queryString = new URLSearchParams(filters).toString(); // 필터 조건을 쿼리 스트링으로 변환
        console.log("검색어 :" , queryString);

        
        const response = await fetchData(`expenses/?${queryString}`);
        this.expenses = response.data?.results || response.data || []
        

        console.log("pina : expenses: ",this.expenses);

      }catch(error){
        console.log("Error fetching expresses",error);
      }finally{
        this.isLoading = false;
      }
    },
    async fetchExpense(id) {
      this.isLoading = true; // 로딩 시작
      try{        
        
        const response   = await fetchData(`expenses/${id}/`);
        this.expense = response.results
        
      }catch(error){
        console.log("Error fetching expresses",error);
      }finally{
        this.isLoading = false;
      }
    },
    
    async createExpense(data) {
      const response = await createData('expenses/', data);
      this.expenses.push(response.data);
    },
    async updateExpense(id, data) {
      await updateData(`expenses/${id}/`, data);
      this.fetchExpenses();
    },
    async deleteExpense(id) {
      await deleteData(`expenses/${id}/`);
      this.fetchExpenses();
    },
  },
});